module.exports = __webpack_public_path__ + "static/img/124.4c383d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/124.jpg
// module id = MnFl
// module chunks = 0